import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import chunk from 'lodash/chunk';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import { ButtonV2, Checkbox, Icon, Link } from 'components';
import './style.scss';

class EditRoomAssignmentV2 extends Component {
  static propTypes = {
    // A function that closes the modal window
    onClose: PropTypes.func,

    // Additional data
    data: PropTypes.object
  };

  constructor(...args) {
    super(...args);

    const { primarySectionId, additionalSectionIds, staffPermissions } = this.props.data;

    this.state = {
      primaryId: primarySectionId,
      additionalIds: [...additionalSectionIds],
      isLoading: false,
      roomVisibility: staffPermissions.room_visibility === 'write' ? true : false 
    };
  }

  @bind
  async submit() {
    const { onClose, currentTeacherId } = this.props;
    const { staffId, successMessage = 'Updated Staff' } = this.props.data;
    const { additionalIds, primaryId, roomVisibility } = this.state;

    this.setState({ isLoading: true });

   const allowPermissionUpdate = staffId !== currentTeacherId;

    const payload = {
      id: staffId,
      teacher: {
        section_id: primaryId,
        secondary_section_ids: additionalIds,
        skip_invite: true // always skip invite on update
      }
    };

    const roomVisibilityPayload = {
      id: staffId,
      permissions: {
        room_visibility: roomVisibility ? "write" : "none"
      }
    }

    try {
      await req.updateStaffItem(payload);

      if (allowPermissionUpdate) {
        await req.updateStaffPermissions(roomVisibilityPayload);
      }

      Actions.showFlash(successMessage);
      onClose(true);
    } catch (err) {
      this.setState({ isLoading: false });
      Actions.reportError('There was problem updating staff', err);
    }
  }

  @bind
  onPrimaryClick(id) {
    this.setState(state => ({
      primaryId: state.primaryId === id ? null : id
    }));
  }

  @bind
  onSectionChange(sectionId) {
    const { additionalIds } = this.state;
    let nextIds;

    if (additionalIds.includes(sectionId)) {
      nextIds = additionalIds.filter(id => sectionId !== id);
    } else {
      nextIds = [...additionalIds, sectionId];
    }
    this.setState({
      additionalIds: nextIds
    });
  }

  @bind
  onPermissionChange() {
    this.setState(
      prevState => ({
        roomVisibility: !prevState.roomVisibility
      }),
    );
  }

  render() {
    const { isLoading, primaryId, additionalIds, roomVisibility } = this.state;
    const { sections, onClose } = this.props;
    const { isAdmin } = this.props.data;

    return (
      <div className="edit-staff-sections">
        <div className="modal__header">
          <span className="modal__header-title">Edit Room Assignment</span>
        </div>

        <div className="modal__container">
          <div className="edit-staff-sections__description">
            Assigning rooms to staff ensures they receive the right push notifications for parent messages and check-ins. Their primary room will be the default room shown when they log into the mobile app.
            <br />
            <br />
            To set a primary room hover over the room name and select this icon. {' '} 
            <Icon className="edit-staff-sections__description-primary" name="room" size={26} /> {' '}
            Use the checkboxes to assign additional rooms.
          </div>
          <div className="edit-staff-sections__options">
            <Scrollbars autoHeight autoHeightMin={0} thumbSize={48}>
              {chunk(sections, 2).map(chunk => {
                return (
                  <div className="edit-staff-sections__options-row">
                    {chunk.map(section => {
                      return (
                        <div className="edit-staff-sections__options-item">
                          <Checkbox
                            key={section.id}
                            checked={additionalIds.includes(section.id)}
                            data-cy={`check-room-${section.id}`}
                            label={section.name}
                            type={'square'}
                            disabled={isLoading}
                            onChange={() => this.onSectionChange(section.id)}
                          />
                          <Icon
                            className={cx('edit-staff-sections__options-primary', {
                              'edit-staff-sections__options-primary--selected': primaryId === section.id
                            })}
                            name={primaryId === section.id ? 'room-gradient' : 'room'}
                            size={26}
                            data-cy={`primary-room-${section.id}`}
                            onClick={() => this.onPrimaryClick(section.id)}
                          />
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </Scrollbars>
            <div className="modal__header">
              <span className="modal__header-title">Edit Room Visibility</span>
            </div>
            <div className="edit-staff-sections__room-visibility">
              <div className="edit-staff-sections__room-visibility-description">
                Room Visibility allows a staff member to access all rooms. Disable this setting to restrict a staff member's access to only their assigned rooms. This can also be edited in Roles & Permissions.
              </div>
              <div className="edit-staff-sections__room-visibility-row">
                <Checkbox
                  className="edit-staff-sections__room-visibility-checkbox"
                  checked={roomVisibility}
                  label={"Room Visibility"}
                  type={'square'}
                  disabled={isLoading || isAdmin}
                  onChange={() => this.onPermissionChange()}
                />
                <div className="edit-staff-sections__room-visibility-link">
                  <Link to="https://www.procaresupport.com/procare-online/docs/assigning-rooms-to-staff">
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal__controls">
          <ButtonV2 label={'Cancel'} secondary onClick={onClose} />
          <ButtonV2 label={'Save Changes'} data-cy={'save'} onClick={this.submit} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  sections: state.rooms.data,
  currentTeacherId: state.currentUser.data.teacher.id
});

export default connect(mapStateToProps)(EditRoomAssignmentV2);
